var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_FILL0_wght400_GRAD0_opsz48",
    d: "M7,18a1.025,1.025,0,0,1-1-1V7A1.025,1.025,0,0,1,7,6H17a1.025,1.025,0,0,1,1,1V17a1.025,1.025,0,0,1-1,1Zm0-1H17V7H7Zm.933-1.617h8.15l-2.45-3.267-2.2,2.85L9.883,12.85ZM7,17v0Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a18b54780762af034118cd26955f60e7.svg";
export { ForwardRef as ReactComponent };